<script setup lang="ts">
defineProps({
	title: {
		type: String,
		default: "Title"
	},
	closeButtonText: {
		type: String,
		default: ""
	},
	submitButtonText: {
		type: String,
		default: "Submit"
	},
	submitButtonActive: {
		type: Boolean,
		default: true
	},
	backdrop: {
		type: Boolean,
		default: true
	}
});
defineEmits(["close", "submit"]);

let bodyEl: HTMLElement;
onMounted(() => {
	bodyEl = document.body;
	bodyEl.style.overflow = "hidden";
});
onUnmounted(() => {
	bodyEl.style.overflow = "";
});
</script>

<template>
	<div
		class="fixed top-0 left-0 z-40 w-screen h-screen flex items-center justify-center"
		:class="backdrop && 'bg-gray-900/40'"
	>
		<div class="max-w-[640px] w-full bg-gray-0 rounded-sm">
			<form @submit.prevent="$emit('submit')">
				<div
					class="flex justify-between p-4 pl-6"
				>
					<span class="pt-5 font-semibold text-xl">{{ title }}</span>
					<CommonButtonClose
						v-if="closeButtonText"
						:size="20"
						@click.prevent="$emit('close')"
					/>
				</div>
				<div class="px-6 pb-10">
					<slot>
						<span class="text-gray-500">
							This is body. Place here any data via slot
						</span>
					</slot>
				</div>
				<div class="flex justify-end pt-4 px-6 pb-5 border-t">
					<AppButton
						v-if="closeButtonText"
						wide
						class="mr-2"
						@click.prevent="$emit('close')"
					>
						{{ closeButtonText }}
					</AppButton>
					<AppButton
						:disabled="!submitButtonActive"
						type="submit"
						fill
						wide
					>
						{{ submitButtonText }}
					</AppButton>
				</div>
			</form>
		</div>
	</div>
</template>
